/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import Container from "../../../Container/Container";
import _upperCase from "lodash/upperCase";
import partnerLogoSectionStyle from "./partnerLogoSectionStyle";
import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "../../../../services/reactQuery/reactQueryService";
import { Box } from "@mui/material";
import { Partner } from "../../../../types/Partner";
import ApiClient from "../../../../services/apiClient";
import type { PartnerIri } from "../../../../constants/partnerIris";
import legalbirdLogoKoop from "../../../../assets/img/logo/legalbird-logo-koop.png";

type PartnerLogoSectionProps = {
  containerStyle?: "divorceContainer" | "settlementContainer" | "smallPaddingContainer";
  partnerIri: PartnerIri;
};

const PartnerLogoSection = ({ containerStyle = "divorceContainer", partnerIri }: PartnerLogoSectionProps) => {
  const { data: partnerEntity, isLoading } = useQuery({
    queryKey: [...queryKeys.all(partnerIri), "logo"],

    queryFn: async (): Promise<Partner | null> => {
      return (await ApiClient.get(partnerIri)) as Partner;
    },

    enabled: !!partnerIri
  });
  if (isLoading || !partnerEntity?.encodedLogo) {
    return null;
  }

  return (
    <Container sx={partnerLogoSectionStyle[containerStyle]}>
      <Box sx={partnerLogoSectionStyle.logoGridContainer}>
        <Box sx={partnerLogoSectionStyle.logoGridItem}>
          <Box
            component={"img"}
            sx={partnerLogoSectionStyle.logo}
            src={partnerEntity.encodedLogo}
            alt={_upperCase(partnerEntity.name ?? "") + " Kooperation Logo"}
          />
        </Box>
        <Box sx={partnerLogoSectionStyle.logoGridItem}>
          <Box component={"img"} sx={partnerLogoSectionStyle.logo} src={legalbirdLogoKoop} alt={_upperCase(partnerEntity.name ?? "") + " Kooperation Logo"} />
        </Box>
      </Box>
    </Container>
  );
};

export default PartnerLogoSection;
